<template>
  <form>
    <div class="category-top-bar sticky-header">
      <div class="top-bar">
       <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="backButton">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
       </p>
       <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="id" @click.prevent="deleteUserLabel">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>

    <div class="row mar-to-15 mar-bt-15" style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="col-lg-6 col-md-12">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>
          <div class="card-content">
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">{{$t('marketingFidelities.name')}}</label>
                  <input type="text"
                    name="name"
                    :placeholder="$t('marketingFidelities.name')"
                    v-model="model.name"
                    v-validate="modelValidations.name"
                    class="form-control">
                </div>
              </div>
              <div class="col-md-12" v-if="fidelitiesLabelsPrimaryOption == 'ordersValue'">
                <div class="form-group">
                  <label for="name">{{$t('marketingFidelities.ordersValue')}}</label>
                  <input type="number"
                    :placeholder="$t('marketingFidelities.value')"
                    v-validate="modelValidations.order_value"
                    :class="{ 'user-label-error-check' : model.showError }"
                    v-on:keyup="checkValueOrNumber(model)"
                    v-model="model.order_value"
                    class="form-control removed_arrow" >
                  <span v-show="model.showError" class="help text-danger"> {{$t('marketingFidelities.orderNumberRequired')}}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="fidelitiesLabelsPrimaryOption == 'ordersNumber'">
                <div class="form-group">
                  <label for="name">{{$t('marketingFidelities.ordersNumber')}}</label>
                  <input type="number"
                    :placeholder="$t('marketingFidelities.number')"
                    :class="{ 'user-label-error-check' : model.showError }"
                    v-validate="modelValidations.order_numbers"
                    v-on:keyup="checkValueOrNumber(model)"
                    v-model="model.order_numbers"
                    class="form-control removed_arrow" >
                  <span v-show="model.showError" class="help text-danger"> {{$t('marketingFidelities.orderNumberRequired')}}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="fidelitiesLabelsPrimaryOption == 'MOR'">
                <div class="row">
                  
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="name">{{$t('marketingFidelities.MORCalcComenzi')}}</label>
                      <input type="number"
                        :placeholder="$t('marketingFidelities.number')"
                        :class="{ 'user-label-error-check' : model.showError }"
                        v-model="morValCalc"
                        class="form-control removed_arrow" >
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="name">{{$t('marketingFidelities.MOR')}}</label>
                      <input type="number"
                        :placeholder="$t('marketingFidelities.number')"
                        :class="{ 'user-label-error-check' : model.showError }"
                        v-validate="modelValidations.mor_value"
                        v-on:keyup="checkValueOrNumber(model)"
                        v-model="model.mor_value"
                        class="form-control removed_arrow" >
                      <span v-show="model.showError" class="help text-danger"> {{$t('marketingFidelities.orderNumberRequired')}}</span>
                    </div>
                  </div>

                </div>
                
                <div class="info" v-html="$t('marketingFidelities.MORInfo')"></div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                    <label for="name">{{$t('marketingFidelities.color')}}</label>
                  <ChromePicker
                    :value="model.color"
                    @input="updateColor($event)"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">{{$t('marketingFidelities.description')}}</label>
                  <input type="text"
                    v-model="model.notification"
                    :title="model.notification"
                    :placeholder="$t('marketingFidelities.descriptionPlaceholder')"
                    class="form-control">
                    <small><i class="fa fa-info-circle" aria-hidden="true"></i>{{$t('marketingFidelities.descriptionInfo')}}</small>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">{{$t('marketingFidelities.coupon')}}</label>
                  <input type="text"
                    v-model="model.coupon"
                    :placeholder="$t('marketingFidelities.coupon')"
                    class="form-control">
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">{{$t('marketingFidelities.product')}}</label>
                  <select class="form-control"
                    v-model="model.product_id"
                    v-validate="modelValidations.productId">
                    <option value="null" :selected="true">{{$t('marketingFidelities.noReccurence')}}</option>
                    <template v-for="product in products">
                      <option :value="product.id" :key="`${product.id}-product`">{{product.name}}</option>
                    </template>
                  </select>
                  <small><i class="fa fa-info-circle" aria-hidden="true"></i>{{$t('marketingFidelities.availableProducts')}}</small>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">{{$t('marketingFidelities.recurrence')}}</label>
                  <select class="form-control" v-model="model.recurrence">
                    <option
                      v-for="(opt, key) in fidelitiesReccurenceOptions"
                      :value="key"
                      :key="key">{{$t('marketingFidelities.'+opt)}}
                    </option>
                  </select>
                  <small><i class="fa fa-info-circle" aria-hidden="true"></i>{{$t('marketingFidelities.recurrenceInfo', {recurrence: model.recurrence !== '0' ? $t('marketingFidelities.'+fidelitiesReccurenceOptions[model.recurrence]) : '-'})}}</small>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">{{$t('marketingFidelities.userNotification')}}</label>
                  <textarea
                    class="form-control label-notification-textarea"
                    rows="4"
                    v-model="model.user_notification"
                    :placeholder="$t('marketingFidelities.userNotificationPlaceholder', {level: model.name})">
                  </textarea>
                  <small><i class="fa fa-info-circle" aria-hidden="true"></i>{{$t('marketingFidelities.userNotificationInfo')}}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12" >
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div class="card-content">
            <div class="header" style="margin: -15px 0 30px !important">
              <h5>{{$t('settingsRewards.moneySpent')}}</h5>
            </div>
            <div class="form-group">
              <div class="delivery_method">
                <div class="delivery_method_points">
                  <label>{{$t('settingCompany.delivery')}}</label>
                  1 {{currency}} =
                  <input type="number"
                    min="1"
                    step="1"
                    name="loyalty_value_one_currency_delivery"
                    v-model="model.loyalty_points.delivery"
                    class="form-control in-inline"> {{$t('settingsRewards.plural')}}

                  <small class="text-danger"  v-if="errors.has('loyalty_value_one_currency')">
                    {{ getError('loyalty_value_one_currency') }}
                  </small>
                </div>
                <div class="delivery_method_points">
                  <label>{{$t('settingCompany.eat_location')}}</label>
                  1 {{currency}} =
                  <input type="number"
                    min="1"
                    step="1"
                    name="loyalty_value_one_currency_eat_location"
                    v-model="model.loyalty_points.eat_location"
                    class="form-control in-inline"> {{$t('settingsRewards.plural')}}

                  <small class="text-danger"  v-if="errors.has('loyalty_value_one_currency')">
                    {{ getError('loyalty_value_one_currency') }}
                  </small>
                </div>
                <div class="delivery_method_points">
                  <label>{{$t('settingCompany.meet_half')}}</label>
                  1 {{currency}} =
                  <input type="number"
                    min="1"
                    step="1"
                    name="loyalty_value_one_currency_meet_half"
                    v-model="model.loyalty_points.meet_half"
                    class="form-control in-inline"> {{$t('settingsRewards.plural')}}

                  <small class="text-danger"  v-if="errors.has('loyalty_value_one_currency')">
                    {{ getError('loyalty_value_one_currency') }}
                  </small>
                </div>
                <div class="delivery_method_points">
                  <label>{{$t('settingCompany.pick_up')}}</label>
                  1 {{currency}} =
                  <input type="number"
                    min="1"
                    step="1"
                    name="loyalty_value_one_currency_pick_up"
                    v-model="model.loyalty_points.pick_up"
                    class="form-control in-inline"> {{$t('settingsRewards.plural')}}

                  <small class="text-danger"  v-if="errors.has('loyalty_value_one_currency')">
                    {{ getError('loyalty_value_one_currency') }}
                  </small>
                </div>
                <div class="delivery_method_points">
                  <label>{{$t('settingCompany.self_ordering')}}</label>
                  1 {{currency}} =
                  <input type="number"
                    min="1"
                    step="1"
                    name="loyalty_value_one_currency_self_ordering"
                    v-model="model.loyalty_points.self_ordering"
                    class="form-control in-inline"> {{$t('settingsRewards.plural')}}

                  <small class="text-danger"  v-if="errors.has('loyalty_value_one_currency')">
                    {{ getError('loyalty_value_one_currency') }}
                  </small>
                </div>
                <br>
                <span class="help-block"><i class="fa fa-info-circle" aria-hidden="true"></i>{{$t('settingsRewards.numberOfcurrencyNeedToSpend', {currency: currency})}}</span>
                <span class="help-block"><i class="fa fa-info-circle" aria-hidden="true"></i>{{$t('settingsRewards.default')}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import Vue from 'vue'
  // import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import { Chrome } from 'vue-color'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)

  export default {
    components: {
      ChromePicker: Chrome,
      [Button.name]: Button,
      [Input.name]: Input
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    created () {
      this.loading = true
      this.getProducts()
      if (this.route.params.id) {
        this.getUserLabeling()
      }
      this.fidelitiesLabelsPrimaryOption = this.$session.get('selectedCompanyData').fidelities_labels_primary_option

      if (this.fidelitiesLabelsPrimaryOption === 'ordersValue') {
        Vue.set(this.modelValidations, 'order_value', {required: true})
      }
      if (this.fidelitiesLabelsPrimaryOption === 'ordersNumber') {
        Vue.set(this.modelValidations, 'order_numbers', {required: true})
      }
      if (this.fidelitiesLabelsPrimaryOption === 'MOR') {
        Vue.set(this.modelValidations, 'mor_value', {required: true})
      }
    },
    data () {
      return {
        id: this.route.params.id || null,
        currency: this.getCompanyDetail('currency'),
        fidelitiesLabelsPrimaryOption: null,
        model: {
          name: '',
          orderValue: null,
          orderNumbers: null,
          color: '#000',
          notification: '',
          coupon: '',
          product_id: null,
          recurrence: 0,
          user_notification: '',
          showError: false,
          loyalty_points: {
            delivery: null,
            eat_location: null,
            pick_up: null,
            self_ordering: null,
            meet_half: null
          }
        },
        modelValidations: {
          name: {
            required: true,
            min: 3
          },
          color: {
            required: true
          }
        },
        colors: {
          red: '#f7786b',
          green: '#d9ecd0',
          blue: '#92a8d1',
          yellow: '#ffef96',
          orange: 'orange',
          pink: '#eca1a6',
          aqua: '#80ced6',
          navy: 'navy',
          maroon: 'maroon',
          olive: 'olive',
          white: 'white',
          grey: '#888888',
          black: 'black'
        },
        isNew: true,
        loading: true,
        products: [],
        fidelitiesReccurenceOptions: {
          0: 'noReccurence',
          1: 'oneDay',
          3: 'threeDays',
          5: 'fiveDays',
          7: 'sevenDays',
          10: 'tenDays',
          15: 'fifteenDays',
          20: 'twentyDays',
          25: 'twentyFiveDays'
        }
      }
    },
    computed: {
      morValCalc: {
        get () {
          return this.model.mor_value
            ? Math.round(this.model.mor_value * 12)
            : null
        },
        set (value) {
          this.model.mor_value = value
            ? Number((value / 12).toFixed(2))
            : null
        }
      }
    },
    methods: {
      updateColor (newColor) {
        this.model.color = newColor.hex
      },
      getProducts () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/user-labeling-products', 'GET', data, response => {
          if (response.status === true) {
            this.products = response.data
            this.loading = false
          }
        })
      },
      checkValueOrNumber (item) {
        if (item) {
          item.showError = false
        } else {
          this.model.showError = false
        }
      },
      getUserLabeling () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/userlabeling/' + this.id, 'GET', data, response => {
          if (response.status === true) {
            this.model = response.data
            // this.model = response.data.map(value => ({
            //   ...value,
            //   showError: false
            // }))
          }
          this.$nextTick(() => {
            this.loading = false
          })
        })
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.updateOrCreateUserLabel() }
        })
      },
      updateOrCreateUserLabel () {
        const data = {
          'company_id': this.$session.get('selectedCompany'),
          'token': this.$session.get('token'),
          'id': this.id,
          'name': this.model.name,
          'order_value': this.model.order_value,
          'order_numbers': this.model.order_numbers,
          'mor_value': this.model.mor_value,
          'color': this.model.color,
          'notification': this.model.notification,
          'user_notification': this.model.user_notification,
          'coupon': this.model.coupon,
          'product_id': this.model.product_id,
          'recurrence': this.model.recurrence,
          'loyalty_points': this.model.loyalty_points
        }

        let url = '/userlabeling/'
        let httpMethod = ''

        if (this.id) {
          url += this.id
          httpMethod = 'PUT'
        } else {
          httpMethod = 'POST'
        }

        this.apiRequest(url, httpMethod, data, response => {
          if (response.status === true) {
            swal(
              '',
              'Success',
              'success'
            )
            this.backButton()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      deleteUserLabel () {
        this.$nextTick(() => { this.loading = true })
        var data = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/userlabeling/' + this.id, 'DELETE', data, (response) => {
          if (response.status) {
            this.$nextTick(() => { this.loadingReset = false })
            swal({'text': 'Success', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
            this.backButton()
          } else {
            this.$nextTick(() => { this.loadingReset = false })
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
        })
      },
      backButton () {
        // this.router.push('/marketing/fidelities?tabIndex=1')
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>
<style scoped>
  .delivery_method_points{
    display: flex;
    align-items: center;
    gap: 30px;
  }

  .delivery_method_points :first-child {
    width: 300px;
  }
</style>
<style>
  .info {
    margin-top: 0;
    margin-bottom: 20px;
  }
  .info p {
    font-size: 12px !important;
    margin: 0;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Fidelities/UserLabel/UserLabelingForm.vue